import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box, FlexColumn, Title } from "@similarweb/ui-components";

import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const BoxSubtitleLayout = styled(BoxSubtitle)`
    flex-wrap: wrap;
    row-gap: 8px;
    margin-top: 6px;
`;

const BoxContainer = styled(Box)`
    width: 100%;
    max-width: 1368px;
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    margin-bottom: 24px;
    height: 386px;
`;

export const StyledBoxContainer = styled(BoxContainer)`
    height: 100%;
    justify-content: space-between;
    border-radius: 8px;
    overflow: hidden;
    min-width: 427px;
`;

export const TitleBox = styled(FlexColumn)`
    flex: 1;
    justify-content: space-between;
    padding: 20px;
    gap: 20px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledHeaderTitle = styled(Title).attrs<{ "data-automation-box-title"?: boolean }>((props) => ({
    "data-automation-box-title": true,
}))`
    font-size: 20px;

    ${InfoIcon} {
        line-height: 1.55;
    }
`;

export const LoaderWrapper = styled(CenteredFlexRow)`
    flex: 1;
    min-height: 345px;
`;

export const TableContainer = styled.div<{ tableHeight: string }>`
    height: ${({ tableHeight }) => tableHeight};
    overflow: hidden;
    position: relative;
`;

export const GradientOverlay = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 67px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.88) 100%);
    pointer-events: none;
    z-index: 2;
`;
